module.exports = __webpack_public_path__ + "static/img/increase-lead-data02.ed25cc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/increase-lead-data02.jpg
// module id = l8Vh
// module chunks = 1